import React, { createContext, useCallback, useState, useContext } from 'react';
import api from '../services/api';

interface AuthState {
  token: string;
  user: object;
}

interface SignInCredentials {
  email: string;
  password: string;
}

interface IUser {
  id: any;
  email_verified_at: any;
  created_at: string;
  updated_at: string;
  store_id: number;
  file_id: any;
  file: any;
  role: any;
  store: any;
  email: string;
  name: string;
}

interface AuthContextData {
  user: any;
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
  updatedUser(data: IUser): any;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const AuthProvider: React.FC = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const token = localStorage.getItem('@AppCambio:token');
    const user = localStorage.getItem('@AppCambio:user');

    if (token && user) {
      api.defaults.headers.authorization = `Bearer ${token}`;
      return { token, user: JSON.parse(user) };
    }
    return {} as AuthState;
  });

  const signIn = useCallback(async ({ email, password }) => {
    const response = await api.post('/sessions', {
      email,
      password,
    });

    const { token, user } = response.data;
    localStorage.setItem('@AppCambio:token', token);
    localStorage.setItem('@AppCambio:user', JSON.stringify(user));

    api.defaults.headers.authorization = `Bearer ${token}`;

    setData({ token, user });
  }, []);

  const signOut = useCallback(() => {
    localStorage.removeItem('@AppCambio:token');
    localStorage.removeItem('@AppCambio:user');

    setData({} as AuthState);
  }, []);

  const updatedUser = useCallback((user: any) => {
    localStorage.setItem('@AppCambio:user', JSON.stringify(user));
    setData({ token: data.token, user })
  }, [data]);

  return (
    <AuthContext.Provider value={{ user: data.user, signIn, signOut, updatedUser }}>
      {children}
    </AuthContext.Provider>
  );
};

function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error(' useAuth must be used within an authProvider ');
  }
  return context;
}
export { AuthProvider, useAuth };
